// Apply Job Modals
export const APPLICATION_SENT_SUCCESSFUL_SCREEN_SHOWN =
	"Application sent successful screen shown";
export const APPLICATION_SENT_SUCCESSFUL_SCREEN_CTA_CLICKED =
	"Application sent successful screen CTA Clicked";
export const WEB_JOB_APPLICATION_INELIGIBLE_SCREEN_SHOWN =
	"Web Job Application Ineligible Screen Shown";
export const WEB_JOB_APPLICATION_INELIGIBLE_SCREEN_CTA_CLICKED =
	"Web Job Application Ineligible Screen CTA Clicked";
